import React, { Children, useEffect, useRef, useState } from 'react'
import { DefaultButton } from 'components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { V1ApiSharedClient } from 'core/http-common'
import toast from 'core/toast'
import { CreateWatcherDto, WatcherDto, WatcherDtoApiResponseDto } from 'generated/v1/v1SharedApi'

interface IProps {
    id: number
    watcherType: WatcherTypeEnum
}

export enum WatcherTypeEnum {
    Dealer = 1,
    Case = 2
}

const Watcher = (props: IProps) => {

    const watchString = 'Watch'

    const [watchTypeText, setWatchTypeText] = useState(props.watcherType === WatcherTypeEnum.Dealer ? 'Dealer' : 'Case')
    const [watchStatusText, setWatchStatusText] = useState(watchString)


    const fetchData = async () => {
        let watchResponse = null as WatcherDto | null
        try {

            if (props.watcherType === WatcherTypeEnum.Dealer) {
                watchResponse = await V1ApiSharedClient.getDealerWatcher(props.id)
            } else if (props.watcherType === WatcherTypeEnum.Case) {
                watchResponse = await V1ApiSharedClient.getCaseWatcher(props.id)
            }

            if (watchResponse) {
                setWatchStatusText('Unwatch')
            } else {
                setWatchStatusText(watchString)
            }

        } catch (error) {
            toast.responseErrors(error)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])


    const handleWatch = async () => {
        let watchResponse = undefined as WatcherDtoApiResponseDto | undefined
        const watchBool = watchStatusText === watchString ? true : false

        if (props.watcherType === WatcherTypeEnum.Dealer) {
            watchResponse = await V1ApiSharedClient.setDealerWatcher(props.id, new CreateWatcherDto({ watch: watchBool }))
        } else if (props.watcherType === WatcherTypeEnum.Case) {
            watchResponse = await V1ApiSharedClient.setCaseWatcher(props.id, new CreateWatcherDto({ watch: watchBool }))
        }
        fetchData()
    }

    return (
        <DefaultButton
            className='me-1 btn-sm'
            variant='default'
            onClick={handleWatch}>
            <FontAwesomeIcon icon={faEye} />{' '}
            {watchStatusText} {watchTypeText}
        </DefaultButton>
    )

}

export default Watcher